
export const ISKN_EXPLORER_SET_ISKN_DATE_ACTION_TYPE = 'isknExplorer/SET_ISKN_DATE';

export default function getActions(dispatch) {
    return {
        setIsknDate: (isknDate) => dispatch({
            type: ISKN_EXPLORER_SET_ISKN_DATE_ACTION_TYPE,
            isknDate
        })
    };
}
